/* eslint-disable max-lines-per-function */
import React from 'react'
import { Downgraded, type State } from '@hookstate/core'
import type { ResponseProps } from '~/features/Management/interfaces'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import PieChartMui from '~/components/PieChartMui'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import ColumnChartVertical from '~/components/ColumnChartMui/VerticalChart'
import useManagementQualifiersVehicleState from '~/features/Management/stores/ManagementQualifiersVehicleState'
import { calculateBarChartTotal } from '~/utils/format'

interface ChartsVehicleProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsVehicle({
  expandFilterSearch,
}: ChartsVehicleProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedVehicle } = useManagementQualifiersVehicleState()

  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered vehicles')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartVertical
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedAssossiatedVehicleBytype.attach(Downgraded)
            .get()}
          title={'Vehicle type'}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedAssossiatedVehicleBytype.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate(
            'vehicle-associated occurrences by type of occurrence'
          )}`}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'occurrences types'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByBrand.attach(Downgraded)
            .get()}
          title={`${translate('VehicleBrand:name')}`}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByBrand.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'brands'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByModel.attach(Downgraded)
            .get()}
          title={`${translate('VehicleModel:name')}`}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByModel.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'models'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByCircunstance.attach(Downgraded)
            .get()}
          title={`${translate('Circunstance of the vehicle')}`}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByCircunstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByDestination.attach(Downgraded)
            .get()}
          title={`${translate('Final destination of the vehicle')}`}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByDestination.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'finals destinations'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartVertical
          data={occurrencesAssociatedVehicle()
            .occurrencesAssociatedVehicleByState.attach(Downgraded)
            .get()}
          title={'Vehicles state of origin'}
          subtitle={`Total de veículos: ${calculateBarChartTotal(
            occurrencesAssociatedVehicle()
              .occurrencesAssociatedVehicleByState.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'states'}
          colorBar="primary"
        />
      </Grid>
    </Grid>
  )
}
